import React from 'react';
import { useSiteData, useRouteData, Head } from 'react-static';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Container from '@nmx/template/dist/componentLibrary/foundations/Grid/Container';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ChevronLeftIconStyled,
  LinkStyled,
  LinkStyledBack,
  TypographyStyled,
} from '../styles';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, state, reps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}>
      <SectionContainer id='financial-advisors-state-directory'>
        <LinkStyledBack
          id='back-to-financial-advisor-directory-icon'
          variant='primaryDeemphasize'
          linkUrl='/financial/advisors/'
          startAdornment={ChevronLeftIconStyled}
          startAdornmentStylesReset>
          Back to state directory
        </LinkStyledBack>
        <TypographyStyled component='h1'>
          Directory of Financial Advisors and Representatives <WidowBlock>in {state.name}</WidowBlock>
        </TypographyStyled>
        <Container>
          <Row>
            {reps.map((rep) =>
              (
                <Col
                  small={6}
                  large={4}
                  id={`financial-rep-col-${rep.slug}`}
                  key={rep.id}>
                  <LinkStyled
                    id={`financial-rep-${rep.slug}`}
                    variant='primaryDeemphasize'
                    linkUrl={`/financial/advisor/${rep.slug}/`}
                    ariaLabel={`${rep.title} ${rep.firstName} ${rep.lastName}${rep.lineage ? ` ${rep.lineage}` : ''}`}>
                    {rep.firstName} {rep.lastName} {rep.lineage}
                  </LinkStyled>
                </Col>
              ),
            )}
          </Row>
        </Container>
      </SectionContainer>
    </Page>
  );
};
